import {
  Input,
  OnInit,
  OnDestroy,
  Component,
  Self,
  Optional,
} from '@angular/core';
import {
  AsyncValidatorFn,
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlStatus,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Observable, share, Subject, Subscription, take } from 'rxjs';

@Component({
  template: ``,
})
export abstract class BaseFpxControlComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  /** @description Input Output variables */
  @Input('changePublisher') changePublisher!: Subject<{
    subject: string;
    payload: any;
  }>;
  @Input() formControlName!: string;
  @Input() label: string = '';
  @Input() placeholder: string = '';

  /** @description Template variables */
  selectableDataList$!: Observable<any>;
  formControl!: FormControl;
  loading: boolean = false;
  errorCode: string = '';

  /** @description Private Variables */
  private readonly _syncValidators: ValidatorFn[] = [];
  private readonly _asyncValidators: AsyncValidatorFn[] = [];
  private readonly notifyContext: Map<string, any> = new Map<string, any>();
  private readonly _controlContainer: ControlContainer;
  private changePublisher$!: Subscription;
  private controlStatus$!: Subscription;

  constructor(controlContainer: ControlContainer) {
    this._controlContainer = controlContainer;
  }

  /** @description protected members */
  protected addSyncValidatorFn(syncValidatorFn: ValidatorFn) {
    this._syncValidators.push(syncValidatorFn);
  }

  protected addAsyncValidatorFn(asyncValidatorFn: AsyncValidatorFn) {
    this._asyncValidators.push(asyncValidatorFn);
  }

  protected setSelectableData(selectableDataList$: Observable<any>) {
    this.selectableDataList$ = selectableDataList$;
  }

  /** @description init lifecycle hook */
  ngOnInit(): void {
    let formGroup = this._controlContainer.control as FormGroup;
    this.formControl = formGroup.controls[this.formControlName] as FormControl;
    this.doPreInit();
    this.formControl.addValidators(this._syncValidators);
    this.formControl.addAsyncValidators(this._asyncValidators);
    this.formControl.updateValueAndValidity();

    if (this.changePublisher) {
      console.log(
        'Denomination component subscreibing for changes in parent form'
      );
      this.changePublisher$ = this.changePublisher
        .asObservable()
        .subscribe((response) => {
          this.notifyContext.set(response.subject, response.payload);
          this.doChangeNotify(
            response.subject,
            response.payload,
            this.notifyContext
          );
        });
    }

    this.controlStatus$ = this.formControl.statusChanges.subscribe(
      (res: FormControlStatus) => {
        if (res === 'INVALID') {
          this.errorCode = this.getErrorCode();
        } else {
          this.errorCode = '';
        }
        if (res === 'PENDING') {
          this.loading = true;
        } else {
          this.loading = false;
        }
      }
    );

    this.doPostInit();
  }

  /** @description destroy lifecycle hook */
  ngOnDestroy(): void {
    if (this.changePublisher$) {
      this.changePublisher$.unsubscribe();
    }
    if (this.controlStatus$) {
      this.controlStatus$.unsubscribe();
    }
    this.notifyContext.clear();
    this.doDestroy();
  }

  /** @description return the error code */
  private getErrorCode() {
    return Object.keys(this.formControl.errors as ValidationErrors)[0];
  }

  /** @description control vaule accessor */
  onChange: any = () => {};

  onTouched: () => void = () => {};

  setDisabledState?(isDisabled: boolean): void {
    console.error('isdisable', this.formControlName, isDisabled);
  }

  registerOnChange(fn: any): void {
    console.log(this.formControlName,'registerchange')
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    if (this.formControl && obj != this.formControl.value) {
      this.formControl.setValue(obj, { emitEvent: false });
    }
  }

  public refreshState(): void {
    this.doRefresh();
  }

  /** @description override methods to access the angular life cycle hooks */
  protected doPreInit(): void {}
  protected doPostInit(): void {}
  protected doChangeNotify(
    subject: string,
    payload: any,
    context: Map<string, any>
  ): void {}
  protected doDestroy(): void {}
  protected doRefresh(): void {}
}
